'use strict';

/* global angular */
angular.module('atex.aceui.service').factory('SecurityRoleService',
  ['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

    function ($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
      var serviceHandler = undefined;

      var handler = function () {
        if (serviceHandler !== undefined) {
          return $q.when(serviceHandler);
        }

        return ApplicationConfigurationService.getServiceConfigurationFor('SecurityRoleService')
          .then(function (configuration) {
            var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'security/role');

            var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
            serviceHandler = atex.aceui.service.SecurityRoleService(serviceUrl, serviceSettings);

            return serviceHandler;
          });
      };

      return {
      /*
       */
        getAllRoles: function () {
          return AuthenticationService.callWithAuthentication(function (currentUser) {
            return handler().then(function (serviceHandler) {
              return serviceHandler.getAllRoles({ authToken: currentUser.token });
            });
          });
        }
      };
    }
  ]);
